import React, {Component} from 'react';
import { connect } from 'react-redux';

import MenuListItem from './MenuListItem';

class MenuList extends Component {


    constructor(props) {
        super(props);
    }


    createFormattedSectionData() {
        var restaurantData = [];

        this.props.data.map((category, index) => {
            if(category.linkToSpecials){
                restaurantData.push({title: category.name, generalCategory: 'specials', index: index, data: [this.props.currentLocation.specials]}); 
            }

            if(category.linkToPizzas){
                restaurantData.push({title: category.name, description: category.description, generalCategory: 'pizzas', index: index, data: [this.props.currentLocation.pizzas]}); 
            }

            if(category.food_items && category.food_items.length > 0){
                restaurantData.push({title: category.name, generalCategory: 'food_items', index: index, data: [category.food_items]});
            }
        });

    
        return restaurantData;
    }




    renderCategoryItems(category) {
        if ( category.generalCategory == 'specials' ) {
            return this.props.currentLocation.specials
                .sort((a, b) => a.special_order - b.special_order || a.name.localeCompare(b.name))
                .map((item) => (
                    <MenuListItem
                        menuItemType="special"
                        food={item}
                    />
                ));
        }

        if ( category.generalCategory == 'pizzas' ) {
            if (this.props.currentLocation.hasCustomPizzas) {
                const hasCustomPizzasJSX = (
                    <MenuListItem 
                        menuItemType="custompizza"
                        isCustomPizza={true}
                    />
                )

                const pizzaOptions = this.props.currentLocation.pizzas
                    .sort((a, b) => a.pizza_order - b.pizza_order || a.name.localeCompare(b.name))
                    .map((item) => (
                    <MenuListItem
                        menuItemType="pizza"
                        food={item}
                    />
                ))
                return  (
                    <>
                        {hasCustomPizzasJSX}
                        { pizzaOptions }
                    </>
                );
            } else {
                return this.props.currentLocation.pizzas
                .sort((a, b) => a.pizza_order - b.pizza_order || a.name.localeCompare(b.name))
                .map((item) => (
                   <MenuListItem 
                        food={item}
                        menuItemType="pizza"
                   />
                ))
            }
        } 

        if ( category.generalCategory == "food_items" && category.data.length > 0 ) {
            return category.data[0]
            .sort((a, b) => a.food_order - b.food_order || a.name.localeCompare(b.name))
            .map((item) => (
                <MenuListItem
                    menuItemType="fooditem"
                    food={item}
                />
            ))
        }
    }


    renderMenu(categoryData){
        return categoryData.map((category) => (
        <div className="menuCategoryWrapper">
                {this.renderCategoryHeader(category) }
                {this.renderCategoryItems(category) }
        </div>
        ));
    }

    renderCategoryHeader(category) {
        return (
            <div className="categoryDiv">
                <h2 className="menuCategory" id={category.title.replace(/\s+/g, '')}>{category.title}</h2>
                {(category.description != false && category.description != undefined) && (
                    <p className="categoryNotes">{ category.description }</p>
                )}
            </div>
        )
    }

    render() {
        var categoryData = this.createFormattedSectionData();

        return (
            <div>
                {this.renderMenu(categoryData)}
            </div>
        )   
    }
}

const mapStateToProps = (state) => {
    return {
        currentLocation: state.currentLocation.info,
        assets_url: state.currentLocation.info.assets_url,
   
    };
};


export default connect(mapStateToProps)(MenuList);
